
export const mockCustomerData = [
  {
    customer_email: "ana.silva@email.com",
    customer_name: "Ana Silva Santos",
    reference_order_id: "1234567890",
    total_spent_amount: 350.00,
    order_date: "2025-07-14T00:00:00Z"
  },
  {
    customer_email: "bruno.costa@teste.com",
    customer_name: "Bruno Costa Lima",
    reference_order_id: "1234567891",
    total_spent_amount: 245.50,
    order_date: "2025-07-14T00:00:00Z"
  },
  {
    customer_email: "carla.mendes@mock.com",
    customer_name: "Carla Mendes Rocha",
    reference_order_id: "1234567892",
    total_spent_amount: 180.75,
    order_date: "2025-07-14T00:00:00Z"
  },
  {
    customer_email: "diego.fernandes@demo.com",
    customer_name: "Diego Fernandes Alves",
    reference_order_id: "1234567893",
    total_spent_amount: 420.30,
    order_date: "2025-07-14T00:00:00Z"
  },
  {
    customer_email: "elena.barbosa@example.com",
    customer_name: "Elena Barbosa Freitas",
    reference_order_id: "1234567894",
    total_spent_amount: 165.90,
    order_date: "2025-07-14T00:00:00Z"
  },
  
  // 10 novos mocks para 14/07 meio-dia com telefones
  {
    customer_email: "felipe.santos@email.com",
    customer_name: "Felipe Santos Lima",
    customer_phone: "12981374740",
    reference_order_id: "BULK14071401",
    total_spent_amount: 189.90,
    order_date: "2025-07-14T12:00:00Z"
  },
  {
    customer_email: "gabriela.oliveira@teste.com",
    customer_name: "Gabriela Oliveira Costa",
    customer_phone: "12981374740",
    reference_order_id: "BULK14071402",
    total_spent_amount: 245.75,
    order_date: "2025-07-14T12:00:00Z"
  },
  {
    customer_email: "henrique.pereira@mock.com",
    customer_name: "Henrique Pereira Silva",
    customer_phone: "12981374740",
    reference_order_id: "BULK14071403",
    total_spent_amount: 156.40,
    order_date: "2025-07-14T12:00:00Z"
  },
  {
    customer_email: "isabela.martins@demo.com",
    customer_name: "Isabela Martins Rocha",
    customer_phone: "12981374740",
    reference_order_id: "BULK14071404",
    total_spent_amount: 378.25,
    order_date: "2025-07-14T12:00:00Z"
  },
  {
    customer_email: "joao.rodrigues@example.com",
    customer_name: "João Rodrigues Neto",
    customer_phone: "12981374740",
    reference_order_id: "BULK14071405",
    total_spent_amount: 298.60,
    order_date: "2025-07-14T12:00:00Z"
  },
  {
    customer_email: "larissa.campos@email.com",
    customer_name: "Larissa Campos Vieira",
    customer_phone: "12981374740",
    reference_order_id: "BULK14071406",
    total_spent_amount: 134.80,
    order_date: "2025-07-14T12:00:00Z"
  },
  {
    customer_email: "marcos.silva@teste.com",
    customer_name: "Marcos Silva Souza",
    customer_phone: "12981374740",
    reference_order_id: "BULK14071407",
    total_spent_amount: 445.90,
    order_date: "2025-07-14T12:00:00Z"
  },
  {
    customer_email: "natalia.lopes@mock.com",
    customer_name: "Natália Lopes Ferreira",
    customer_phone: "12981374740",
    reference_order_id: "BULK14071408",
    total_spent_amount: 267.35,
    order_date: "2025-07-14T12:00:00Z"
  },
  {
    customer_email: "otavio.freitas@demo.com",
    customer_name: "Otávio Freitas Barbosa",
    customer_phone: "12981374740",
    reference_order_id: "BULK14071409",
    total_spent_amount: 198.50,
    order_date: "2025-07-14T12:00:00Z"
  },
  {
    customer_email: "patricia.alves@example.com",
    customer_name: "Patrícia Alves Mendes",
    customer_phone: "12981374740",
    reference_order_id: "BULK14071410",
    total_spent_amount: 356.75,
    order_date: "2025-07-14T12:00:00Z"
  }
];

// Mock customers data for the customer management page
export const customers = [
  {
    id: "1",
    name: "Ana Silva Santos",
    email: "ana.silva@email.com",
    phone: "12981374740",
    platform: "Nuvemshop",
    totalSpent: 1250.00,
    totalPurchases: 8,
    status: "Ativo",
    lastPurchase: "2025-01-10",
    acquisitionSource: "Indicação",
    bonusUsed: 45.50,
  },
  {
    id: "2", 
    name: "Bruno Costa Lima",
    email: "bruno.costa@teste.com",
    phone: "12981374740",
    platform: "Shopify",
    totalSpent: 890.75,
    totalPurchases: 5,
    status: "Ativo",
    lastPurchase: "2025-01-08",
    acquisitionSource: "Redes Sociais",
    bonusUsed: 12.30,
  },
  {
    id: "3",
    name: "Carla Mendes Rocha", 
    email: "carla.mendes@mock.com",
    phone: "12981374740",
    platform: "WooCommerce",
    totalSpent: 567.20,
    totalPurchases: 3,
    status: "Inativo",
    lastPurchase: "2024-12-15",
    acquisitionSource: "Google Ads",
    bonusUsed: 0,
  }
];

// Mock purchases data
export const mockPurchases = [
  {
    id: "p1",
    customerId: "1",
    product: "Smartphone Galaxy S24",
    date: "2025-01-10",
    value: "R$ 1.299,99",
    cashbackEarned: "R$ 64,99",
    status: "Concluída"
  },
  {
    id: "p2", 
    customerId: "1",
    product: "Fone Bluetooth",
    date: "2025-01-05",
    value: "R$ 149,90",
    cashbackEarned: "R$ 7,49",
    status: "Concluída"
  },
  {
    id: "p3",
    customerId: "2",
    product: "Notebook Dell",
    date: "2025-01-08",
    value: "R$ 2.499,00",
    cashbackEarned: "R$ 124,95",
    status: "Concluída"
  }
];

// Mock cashback transactions
export const mockCashbackTransactions = [
  {
    id: "cb1",
    customerId: "1", 
    date: "2025-01-10",
    description: "Cashback da compra #1234",
    type: "earned",
    value: "R$ 64,99"
  },
  {
    id: "cb2",
    customerId: "1",
    date: "2025-01-05", 
    description: "Cashback utilizado na compra",
    type: "used",
    value: "R$ -30,00"
  },
  {
    id: "cb3",
    customerId: "2",
    date: "2025-01-08",
    description: "Cashback da compra #1235", 
    type: "earned",
    value: "R$ 124,95"
  }
];

// Mock referrals data
export const mockReferrals = [
  {
    id: "r1",
    referrerId: "1",
    referred: "Maria Santos",
    date: "2024-12-20",
    status: "Ativo",
    purchases: 3,
    reward: "R$ 25,00"
  },
  {
    id: "r2",
    referrerId: "1", 
    referred: "João Silva",
    date: "2024-11-15",
    status: "Ativo",
    purchases: 1,
    reward: "R$ 15,00"
  },
  {
    id: "r3",
    referrerId: "2",
    referred: "Pedro Costa",
    date: "2024-10-10",
    status: "Pendente",
    purchases: 0,
    reward: "R$ 0,00"
  }
];

// Mock activities data
export const mockActivities = [
  {
    id: "a1",
    customerId: "1",
    type: "purchase",
    description: "Realizou uma compra de R$ 1.299,99",
    date: "2025-01-10T14:30:00Z"
  },
  {
    id: "a2",
    customerId: "1",
    type: "referral", 
    description: "Indicou novo cliente: Maria Santos",
    date: "2024-12-20T10:15:00Z"
  },
  {
    id: "a3",
    customerId: "1",
    type: "login",
    description: "Acessou a plataforma", 
    date: "2025-01-09T16:45:00Z"
  },
  {
    id: "a4",
    customerId: "2",
    type: "cashback_used",
    description: "Utilizou R$ 50,00 de cashback",
    date: "2025-01-08T11:20:00Z"
  },
  {
    id: "a5",
    customerId: "2",
    type: "wishlist",
    description: "Adicionou produto à lista de desejos",
    date: "2025-01-07T09:30:00Z"
  }
];

// Mock messages data
export const mockMessages = [
  {
    id: "m1",
    customerId: "1",
    content: "Olá! Seu pedido foi processado com sucesso. Você ganhou R$ 64,99 de cashback!",
    date: "2025-01-10T15:00:00Z",
    status: "Lida",
    template: "Confirmação de Pedido"
  },
  {
    id: "m2", 
    customerId: "1",
    content: "Temos uma promoção especial para você! Use o código SAVE20 e ganhe 20% de desconto.",
    date: "2025-01-05T10:30:00Z",
    status: "Entregue",
    template: "Promoção"
  },
  {
    id: "m3",
    customerId: "2",
    content: "Seu cashback de R$ 124,95 está disponível! Utilize em sua próxima compra.",
    date: "2025-01-08T12:15:00Z", 
    status: "Lida",
    template: "Cashback Disponível"
  },
  {
    id: "m4",
    customerId: "2",
    content: "Não esqueça dos itens em seu carrinho! Finalize sua compra e ganhe cashback.",
    date: "2025-01-06T14:45:00Z",
    status: "Enviada",
    template: "Carrinho Abandonado"
  }
];

// Function to add new message to mockMessages
export const addMessage = (message: any) => {
  mockMessages.push(message);
};
